<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Stany materiałów</span>
        <h3 class="page-title">Stany materiałów</h3>
      </d-col>
    </d-row>

    <d-row>
      <d-col
        lg
        col
        :cols="4"
        v-for="(card, index) in cards" :key="'card-' + index">
        <d-card class="card card-small text-center mb-4">
            <d-card-body>
              <router-link :to="card.link">
                <h3 class="display-4 mt-2 mb-2">
                  <i class="material-icons text-primary" style="font-size: 64px;">
                    {{ card.icon }}
                  </i>
                </h3>

                {{ card.label }}
              </router-link>
            </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: 'materials-stock',
  computed: {
    cards () {
      return [
        {
          label: 'Stany materiałów w produktach',
          icon: 'shopping_cart',
          link: '/stany-materialow/produkty'
        },
        {
          label: 'Materiały i kolory',
          icon: 'palette',
          link: '/stany-materialow/materialy-i-kolory'
        },
        {
          label: 'Historia zużycia',
          icon: 'event_note',
          link: '/stany-materialow/historia-zuzycia'
        }
      ];
    }
  }
};
</script>

